/**
 * Format a latency value in milliseconds.
 * - If >= 1000ms, display as seconds with 2 decimal places (e.g. "1.23s").
 * - Otherwise, display as a rounded integer in ms (e.g. "850ms").
 *
 * @param {number|string} value - Latency in milliseconds.
 * @param {string} [fallback='—'] - Returned when value is null/undefined/non-finite.
 * @returns {string}
 */
export function formatLatency(value, fallback = '—') {
  if (value == null) return fallback;
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (!isFinite(n)) return fallback;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(2)}s`;
  return `${Math.round(n)}ms`;
}
